export default __webpack_public_path__ + "static/media/united-states.c29455bd.svg";